import React, {Fragment} from "react";
import {useContent} from "../../customHooks/useContent";
import content from "../../content/seasons.json";
import {PageHeader} from "../PageHeader";
import {generateRandomKey} from "../../utils/generateRandomKey";

export const Seasons = () => {
    const text = useContent(content);

    const generateSections = (list => list.map(section => (
        <div className="row" key={generateRandomKey()}>
            <section className="col-12">
                <h2>{section.year}</h2>
                {section.paragraphs.map(paragraph => <p key={generateRandomKey()}>{paragraph}</p>)}
            </section>
        </div>
    )));

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-school-seasons"/>
            <main>
                <div className="container header-container">
                    {text?.seasons && generateSections(text.seasons)}
                </div>
            </main>
        </Fragment>
    )
};
